import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createPortal } from 'react-dom'
import { SettingsProvider } from 'core/hooks/settings/useSettings'
import { defaultSettings, isProd } from 'app/settings/defaultSetting'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { LoadScript } from '@react-google-maps/api'
import ErrorBoundary from 'app/ErrorBoundary'
import { ConfigProvider } from 'antd'
import enUSLatest from 'antd/locale/en_US'
import { RouterProvider } from 'react-router'
import { appRoutes } from 'routes/appRoutes'
import AntdTheme from 'styles/AntdTheme'
import { queryClient } from 'core/queryClient'

const App = () => {
  return (
    <>
      {window.location.hostname === 'localhost' &&
        isProd &&
        createPortal(
          <div className="absolute z-10000 top-1.5 left-1/2 -translate-x-1/2 p-1 bg-danger-1 border border-danger-3 rounded-md text-xs text-danger-4 select-none">
            Using <strong>PRODUCTION API</strong> on <strong>local</strong>!
          </div>,
          document.body
        )}
      <QueryClientProvider client={queryClient}>
        <SettingsProvider value={defaultSettings}>
          <GoogleOAuthProvider
            clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID ?? ''}
          >
            <ConfigProvider locale={enUSLatest} theme={AntdTheme}>
              <LoadScript
                libraries={['geometry']}
                googleMapsApiKey={
                  import.meta.env.VITE_APP_GOOGLE_MAPS_KEY ?? ''
                }
              >
                <ErrorBoundary>
                  <RouterProvider router={appRoutes} />
                  {import.meta.env.DEV && (
                    <ReactQueryDevtools
                      initialIsOpen={false}
                      buttonPosition="bottom-right"
                    />
                  )}
                </ErrorBoundary>
              </LoadScript>
            </ConfigProvider>
          </GoogleOAuthProvider>
        </SettingsProvider>
      </QueryClientProvider>
    </>
  )
}

export default App
